<template>
  <BaseToggleButton
    v-bind="$attrs"
    :checked="checked"
    :label="label"
    :help="help"
    :checked-label="checkedLabel"
    :unchecked-label="uncheckedLabel"
    :disabled="disabled"
    @change="handleChange"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { openDownloadModal } from "@/components/modals/download";

import BaseToggleButton from "./BaseToggleButton.vue";

export default defineComponent({
  components: {
    BaseToggleButton,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    help: {
      type: String,
      default: null,
    },
    checkedLabel: {
      type: String,
      default: "",
    },
    uncheckedLabel: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
  },
  emits: {
    change: (_: boolean) => true,
  },
  setup(props, { emit }) {
    const handleChange = (checked: boolean) => {
      openDownloadModal(props.message);
      emit("change", checked);
    };

    return {
      handleChange,
    };
  },
});
</script>
